import { createFileRoute } from '@tanstack/react-router'

import { KioskFindTable } from '@/components/pages/Kiosk/KioskFindTable'

export const Route = createFileRoute('/e/$eventId/_display/kiosk/find-table')({
  component: KioskFindTable,
  staticData: {
    authRequired: false,
  },
})
